window.vendors = window.vendors || {};